// extracted by mini-css-extract-plugin
module.exports = {"container":"Stats_container__3RgLg","text":"Stats_text__3zEfX","border":"Stats_border__rpHrI"};